import  FeedIngredients from './FeedIngredients';

export default FeedIngredients;
